import React, { useEffect, useState } from "react";
import _ from "lodash";
import Box from "@mui/material/Box";
import { useDoc } from "use-pouchdb";
import { useRecoilValue } from "recoil";
import Cancel from "@mui/icons-material/Cancel";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { current } from "./../../utilities/state";
import ImagePreview from "./ImagePreview";

function CameraComponent(props) {

    const [images, setImages] = useState([]);
    const [dataUri, setDataUri] = useState('');
    const _current = useRecoilValue(current);
    const { doc, loading } = useDoc(_current);

    function handleTakePhotoAnimationDone (dataUri) {
        setDataUri(dataUri);
    }

    const cancelPhoto = () => { 
        setDataUri('');
    };

    const handleFileSelect = (fileDataUri) => {
        setDataUri(fileDataUri);
    };

    const saveImages = (image) => {
        let _images = [...images];
        _images.push(image);
        setImages(_images);
        props.saveQuestionImages(_images);
    }

    useEffect(() => {
        if(doc && !loading) {
            let found = _.find(doc.answers, { 'questionId': props.questionId });
            if (found) {
                setImages(found.images);
            }
        }
    }, [doc, loading])

    return (
        <Box sx={{ margin: 2, paddingTop: 2 }}>
            {
                    (dataUri)
                        ? <ImagePreview 
                            dataUri={dataUri} 
                            cancelPhoto={cancelPhoto} 
                            imageproperties={{...props, onFileSelect: handleFileSelect}} 
                            saveImages={saveImages} 
                          />
                        : <Camera onTakePhotoAnimationDone={handleTakePhotoAnimationDone} idealFacingMode={FACING_MODES.ENVIRONMENT} />
            }
            {
                console.log(images)
            }    


            {/* <Box sx={{ margin: 2, paddingTop: 2 }}>
                <Box>
                    <Camera onTakePhoto={onTakePhotoHandler} idealFacingMode="environment" idealResolution={{ width: 640, height: 480 }} isImageMirror={false} isFullscreen={false} imageType={IMAGE_TYPES.JPG} />
                </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", overflow: "scroll" }}>
                {images.map((image, index) => (
                    <Box key={index} sx={{ width: "128px", height: "96px", paddingRight: "12px", position: 'relative', margin: 4 }}>
                        <img alt="cam" src={image} style={{ width: "128px", height: "96px" }} />
                        <Box sx={{ position: 'absolute', right: -12, top: -20 }}>
                            <IconButton component="span" onClick={() => deleteImage(image)} >
                                <Cancel size="xs" color={'warning'} />
                            </IconButton>
                        </Box>
                    </Box>
                ))}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: 'end', paddingBottom: 2 }}>
                <Button variant="outlined" onClick={() => saveImages()}>Save</Button>
                <Box sx={{ width: 20 }} ></Box>
                <Button variant="outlined" onClick={() => props.handleCameraClose()}>Cancel</Button>
            </Box> */}
        </Box>
    );
}

export default CameraComponent;
